import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ContentModerationPanel = ({ items, onModerationAction }) => {
  const [typeFilter, setTypeFilter] = useState('all');

  const typeOptions = [
    { value: 'all', label: 'Tüm İçerikler' },
    { value: 'marketplace', label: 'Pazar Yeri' },
    { value: 'forum', label: 'Forum' },
    { value: 'review', label: 'Yorumlar' }
  ];

  const filteredItems = items?.filter(item => 
    typeFilter === 'all' || item?.type === typeFilter
  );

  const handleApprove = async (item) => {
    console.log('Approve button clicked:', item);
    await onModerationAction('approve', item?.id, item?.type);
  };

  const handleReject = async (item) => {
    console.log('Reject button clicked:', item);
    await onModerationAction('remove', item?.id, item?.type);
  };

  const getTypeLabel = (type) => {
    switch(type) {
      case 'marketplace': return 'Pazar Yeri';
      case 'forum': return 'Forum';
      case 'review': return 'Yorum';
      default: return type;
    }
  };

  const getTypeIcon = (type) => {
    switch(type) {
      case 'marketplace': return 'ShoppingBag';
      case 'forum': return 'MessageSquare';
      case 'review': return 'Star';
      default: return 'AlertCircle';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">İçerik Moderasyonu</h2>
          <span className="inline-flex items-center gap-2 px-3 py-1 bg-error/10 text-error rounded-lg text-sm font-medium whitespace-nowrap">
            <Icon name="AlertTriangle" size={16} />
            {items?.length} bekleyen
          </span>
        </div>
        
        <Select
          options={typeOptions}
          value={typeFilter}
          onChange={setTypeFilter}
          placeholder="İçerik türü filtrele"
        />
      </div>
      <div className="divide-y divide-border">
        {filteredItems?.map((item) => (
          <div key={item?.id} className="p-4 md:p-6 hover:bg-muted/30 transition-smooth">
            <div className="flex flex-col lg:flex-row gap-4">
              {item?.image && (
                <Image
                  src={item?.image}
                  alt={item?.imageAlt}
                  className="w-full lg:w-24 h-24 rounded-lg object-cover flex-shrink-0"
                />
              )}
              
              <div className="flex-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 mb-3">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium bg-secondary/10 text-secondary`}>
                        <Icon name={getTypeIcon(item?.type)} size={12} />
                        {getTypeLabel(item?.type)}
                      </span>
                      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium bg-error/10 text-error">
                        <Icon name="Flag" size={12} />
                        {item?.reportCount} şikayet
                      </span>
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">{item?.title}</h3>
                    <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{item?.content}</p>
                    <div className="flex items-center gap-3 text-xs md:text-sm text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Icon name="User" size={14} />
                        {item?.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <Icon name="Clock" size={14} />
                        {item?.date}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2">
                  <Button
                    variant="success"
                    size="sm"
                    iconName="CheckCircle"
                    iconPosition="left"
                    onClick={() => handleApprove(item)}
                  >
                    Onayla
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Edit"
                    iconPosition="left"
                    onClick={() => onModerationAction('edit', item?.id, item?.type)}
                  >
                    Düzenle
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    iconName="Trash2"
                    iconPosition="left"
                    onClick={() => handleReject(item)}
                  >
                    Kaldır
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Eye"
                    iconPosition="left"
                    onClick={() => onModerationAction('view', item?.id, item?.type)}
                  >
                    Detaylar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {filteredItems?.length === 0 && (
        <div className="p-8 md:p-12 text-center">
          <Icon name="CheckCircle" size={48} className="mx-auto mb-4 text-success opacity-50" />
          <p className="text-muted-foreground">Moderasyon bekleyen içerik yok</p>
        </div>
      )}
    </div>
  );
};

export default ContentModerationPanel;